import * as React from 'react'
import { QuestionFormBaseProps } from '../../../../types'
import { createMarkup } from '../../../../../core/utils/helpers'

const TextBlockQuestion = (props: QuestionFormBaseProps) => {
  const { item } = props

  if (item.disabled) {
    return null
  }

  return (
    <div className="feedback-form-block-question-list-item">
      <div
        className="feedback-form-block-question-list-item__question scheduler-global-fix"
        dangerouslySetInnerHTML={createMarkup(item.question)}
      />
    </div>
  )
}

export default TextBlockQuestion
